export class ContactInfoModel {
    phoneNumber: string;
    email: string;
    nationalId: string;
}